import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

require("./vehicle-type.scss");
@Component({
  standalone: false,
  selector: 'app-vehicle-type',
  templateUrl: './vehicle-type.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleTypeComponent {

  @Input() type: any;

}
